import { useEffect, useState } from "react";
import type { RecommendationCardData } from "@calega/content";
import type { Account } from "../lib/types";
import { api } from "../lib/api";
import { ContentPageView } from "./ContentPage";
import { recommendationRhythm } from "./RecommendationPlanFields";

type Detail = Pick<RecommendationCardData, "id" | "title" | "message" | "contentSlug" | "frequency" | "weekStartsOn" | "recommendedMinutes"> & { completedAt: string | null };

export function RecommendationView({ account, recommendationId }: { account: Account; recommendationId: string }) {
  const [entry, setEntry] = useState<Detail | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    setEntry(null); setError("");
    api<Detail>(`/learning/recommendations/${encodeURIComponent(recommendationId)}`).then((data) => { if (active) setEntry(data); }).catch((caught) => { if (active) setError(caught.message); });
    return () => { active = false; };
  }, [recommendationId, account.id, account.actingAs?.id]);
  if (error) return <div className="alert error">{error}</div>;
  if (!entry || entry.id !== recommendationId) return <div className="loading-card">Empfehlung wird geladen …</div>;
  return <div className="recommendation-page">
    <header className="dashboard-card"><p className="eyebrow">Empfehlung</p><h1>{entry.title}</h1>
      {entry.message && <p className="recommendation-instruction">{entry.message}</p>}
      <p>{recommendationRhythm(entry.frequency, entry.weekStartsOn)}{entry.recommendedMinutes != null ? ` · ${entry.recommendedMinutes} Minuten pro Durchlauf (zur Orientierung)` : ""}</p>
      {entry.completedAt && <p className="muted">Diese Empfehlung ist beendet.</p>}
    </header>
    {!entry.completedAt && <ContentPageView key={entry.id} account={account} slug={entry.contentSlug} recommendationId={entry.id} />}
  </div>;
}
